/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Case_Validation_Liable_Vehicle_RequiredInputs */

const en_case_validation_liable_vehicle_required = /** @type {(inputs: Case_Validation_Liable_Vehicle_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add at least one liable vehicle.`)
};

const pt_br2_case_validation_liable_vehicle_required = /** @type {(inputs: Case_Validation_Liable_Vehicle_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adicione pelo menos um veículo terceiro.`)
};

/**
* | output |
* | --- |
* | "Add at least one liable vehicle." |
*
* @param {Case_Validation_Liable_Vehicle_RequiredInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const case_validation_liable_vehicle_required = /** @type {((inputs?: Case_Validation_Liable_Vehicle_RequiredInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_Validation_Liable_Vehicle_RequiredInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_case_validation_liable_vehicle_required(inputs)
	return pt_br2_case_validation_liable_vehicle_required(inputs)
});